(function () {
  'use strict';

  if (window.__hulkInstallmentsDraftBound) return;
  window.__hulkInstallmentsDraftBound = true;

  var CHECKOUT_LABEL = /continue to checkout/i;
  var SAMPLE_PLANS = /view sample plans/i;
  var INSTALLMENTS_DIALOG = /get it now,\s*pay later|sample plans for/i;
  var inProgress = false;

  function hasPaidHulkOptions() {
    if (document.querySelector('.hulk-buy_now.hulk_buy_now_handle')) return true;

    var selected = document.querySelectorAll(
      '.hulkapps_product_options .price-change:checked, .hulkapps_product_options .price-change:selected, .hulkapps_product_options .swatch_selected'
    );
    var total = 0;
    selected.forEach(function (el) {
      if (el.closest('.hulkapps_option') && el.closest('.hulkapps_option').classList.contains('conditional')) return;
      total += Number(el.getAttribute('data-price') || 0);
    });
    if (total > 0) return true;

    var charged = false;
    document.querySelectorAll("[name^='properties']").forEach(function (input) {
      if (input.type === 'radio' && !input.checked) return;
      if (input.type === 'checkbox' && !input.checked) return;
      var match = String(input.value || '').match(/\[\s*\$\s*([0-9]+(?:\.[0-9]+)?)\s*\]/);
      if (match && Number(match[1]) > 0) charged = true;
    });
    return charged;
  }

  function isCheckoutControl(node) {
    if (!node || node.nodeType !== 1) return false;
    if (!node.matches || !node.matches('button, a, [role="button"]')) return false;
    var text = ((node.getAttribute('aria-label') || '') + ' ' + (node.textContent || '')).replace(/\s+/g, ' ').trim();
    if (SAMPLE_PLANS.test(text)) return false;
    return CHECKOUT_LABEL.test(text);
  }

  function isInstallmentsContext(path) {
    return path.some(function (node) {
      if (!node || !node.tagName) return false;
      if (node.tagName === 'SHOPIFY-PAYMENT-TERMS') return true;
      if (node.getAttribute && node.getAttribute('role') === 'dialog') {
        var label = (node.getAttribute('aria-label') || '') + ' ' + (node.textContent || '');
        return INSTALLMENTS_DIALOG.test(label);
      }
      return false;
    });
  }

  function eventPath(event) {
    if (typeof event.composedPath === 'function') return event.composedPath();
    return [event.target];
  }

  function isInstallmentsCheckoutEvent(event) {
    var path = eventPath(event);
    if (!isInstallmentsContext(path)) return false;
    return path.some(isCheckoutControl);
  }

  function waitFor(check, timeoutMs) {
    return new Promise(function (resolve) {
      var started = Date.now();
      var tick = function () {
        var value = check();
        if (value) {
          resolve(value);
          return;
        }
        if (Date.now() - started >= timeoutMs) {
          resolve(null);
          return;
        }
        window.requestAnimationFrame(tick);
      };
      tick();
    });
  }

  function collectHulkProperties() {
    var props = {};
    document.querySelectorAll("[name^='properties']").forEach(function (input) {
      if (input.classList.contains('hf_property_val') && input.classList.contains('conditional')) return;
      var name = input.name.replace(/^properties\[/, '').replace(/\]$/, '');
      if (!name) return;
      if (input.type === 'radio' && !input.checked) return;
      if (input.type === 'checkbox' && !input.checked) return;
      if (input.type === 'file') return;
      var value = (input.value || '').trim();
      if (value) props[name] = value;
    });
    return props;
  }

  function withShopPayHint(url) {
    if (typeof url !== 'string' || !url) return '/checkout?payment=shop_pay';
    try {
      var parsed = new URL(url, window.location.origin);
      if (!parsed.searchParams.has('payment')) parsed.searchParams.set('payment', 'shop_pay');
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function createHulkDraftOrder() {
    return new Promise(function (resolve, reject) {
      var hulk = window.hulkapps;
      var jq = window.jQuery || window.$;
      if (!hulk || !hulk.po_url || !jq) {
        reject(new Error('Hulk Product Options is not ready'));
        return;
      }

      var quantity = parseInt((document.querySelector('input[name="quantity"]') || {}).value || '1', 10) || 1;
      var variantId = hulk.product.selected_variant;
      var price = hulk.product.selected_variant_price || hulk.product.price;
      var items = [
        {
          product_id: hulk.product.id,
          price: price,
          line_price: price * quantity,
          tags: hulk.product.tags,
          variant_id: variantId,
          quantity: quantity,
          vendor: hulk.product.vendor,
          product_type: hulk.product.type,
          properties: collectHulkProperties(),
          title: hulk.product.title,
        },
      ];
      var collections = {};
      collections[variantId] = hulk.product_collection;

      var payload = {
        cart_json: {
          cart: {
            items: items,
            original_total_price: price * quantity,
            item_count: quantity,
            discounted_price: price * quantity,
          },
          money_format: hulk.money_format,
        },
        store_id: hulk.store_id,
        cart_collections: JSON.stringify(collections),
        customer_tags: hulk.customer ? String(hulk.customer.tags || '').split(',') : '',
        draft_order_language: (window.Shopify && window.Shopify.locale) || '',
        discount_code: '',
        hulk_btn_type: 'ShopifyPay-button',
        default_address: hulk.customer && hulk.customer.default_address ? hulk.customer.default_address : '',
        currency_rate: window.hulkapps_shopify_rate || (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1,
      };

      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        payload.currency_code = window.Shopify.currency.active;
      }
      if (window.Shopify && window.Shopify.country) {
        payload.buyer_country_code = window.Shopify.country;
      }

      jq.ajax({
        type: 'POST',
        url: hulk.po_url + '/store/create_draft_order',
        data: payload,
        crossDomain: true,
        success: function (response) {
          window.location.href = withShopPayHint(typeof response === 'string' ? response : '');
          resolve(true);
        },
        error: function () {
          reject(new Error('create_draft_order failed'));
        },
      });
    });
  }

  function routeThroughHulk() {
    if (inProgress) return;
    inProgress = true;

    var buyNowReady = waitFor(function () {
      return document.querySelector('.hulk-buy_now.hulk_buy_now_handle');
    }, 2500);

    buyNowReady
      .then(function (buyNow) {
        if (buyNow) {
          buyNow.click();
          return true;
        }
        return createHulkDraftOrder();
      })
      .catch(function () {
        inProgress = false;
        window.location.href = '/checkout?payment=shop_pay';
      });
  }

  function onClick(event) {
    if (!isInstallmentsCheckoutEvent(event)) return;
    if (!window.hulkapps || !hasPaidHulkOptions()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeThroughHulk();
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-product-form-installment], form.installment')) return;
    if (!window.hulkapps || !hasPaidHulkOptions()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeThroughHulk();
  }

  function bindRoot(root) {
    if (!root || root.__hulkInstallmentsDraft) return;
    root.__hulkInstallmentsDraft = true;
    root.addEventListener('click', onClick, true);
    root.addEventListener('submit', onSubmit, true);
  }

  function bindExistingShadows(root) {
    bindRoot(root);
    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    elements.forEach(function (el) {
      if (el.shadowRoot) bindExistingShadows(el.shadowRoot);
    });
  }

  bindRoot(document);
  bindExistingShadows(document);

  var observer = new MutationObserver(function () {
    document.querySelectorAll('shopify-payment-terms').forEach(function (el) {
      if (el.shadowRoot) bindRoot(el.shadowRoot);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
